import { useEffect, useMemo } from 'react';
import { playSoundLoop, Sound } from '~/assets/sounds';
import { useDarkMode } from '~/hooks';
import { CharactersList } from '../../components/CharactersList';
import { Head } from '../../components/Head';
import { StyledContainer } from './CharacterSelect.styled';

const CharacterSelect = () => {
	const isDark = useDarkMode();

	const sound = useMemo(
		() => (isDark ? Sound.CharacterDay : Sound.CharacterNight),
		[isDark],
	);

	const stopSound = useMemo(() => playSoundLoop(sound), [sound]);

	useEffect(() => {
		return () => {
			stopSound();
		};
	}, [stopSound]);

	return (
		<StyledContainer>
			<Head />
			<CharactersList />
		</StyledContainer>
	);
};

export { CharacterSelect };
